import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type {
  HtmlComponentProps,
  HtmlComponentDefinition,
  HtmlComponentMapperProps,
  HtmlComponentStateRefs,
} from '../HtmlComponent.types';
import * as translations from '../constants';
import {
  consentPolicyPropsDeps,
  consentPolicyUiTypeMapper,
  getConsentPolicyStateRefs,
  withConsentPolicyProps,
} from '../../ConsentPolicyWrapper/viewer/utils';
import { consentPolicyKeys } from './constants';

export const props = withCompInfo<
  HtmlComponentMapperProps,
  HtmlComponentDefinition,
  HtmlComponentProps
>()(
  ['translate', 'compData', ...consentPolicyPropsDeps],
  (compInfo, carmiData) => {
    const { componentConsentPolicy } = compInfo.compData;
    const { translate } = compInfo;
    const originalProps = {
      ...carmiData,
      translations: {
        title:
          translate(
            translations.HTML_COMPONENT_NAMESPACE,
            translations.HTML_COMPONENT_TITLE_KEY,
          ) || translations.HTML_COMPONENT_TITLE_DEFAULT,
      },
    };
    return {
      componentConsentPolicy,
      ...withConsentPolicyProps(
        compInfo,
        originalProps,
        consentPolicyKeys.componentNameKey,
        consentPolicyKeys.componentNameDefault,
      ),
    };
  },
);

const stateRefs = withStateRefsValues<keyof HtmlComponentStateRefs>([
  'experiments',
  ...getConsentPolicyStateRefs(),
]);

export const uiType = consentPolicyUiTypeMapper;

export default createComponentMapperModel({ props, stateRefs, uiType });
